module.exports = __webpack_public_path__ + "static/beauty-top-banner-section-daefdf8bcdedf21dfa7257219c93c3fc.png";